export default {
  props: {
    /**
      * The current view displayed by the component
      */
    currentView: {type: String, default: 'index'}
  }
};
